import { Selection } from "../../components/Orders/ServiceSelector";
import { PaymentMode } from "../dto/order.dto";
import { Client } from "./client";
import { Staff } from "./staffs";

export interface Order {
  id: string;
  customerId: string;
  orderId: string;
  date: string;
  paid: boolean;
  storeId: string;
  createdAt: string;
  updatedAt: string;
  customer: Client;
  bill: Bill;
  items: any[];
}

export interface Bill {
  id: string;
  orderId: string;
  invoidId: string;
  subtotal: number;
  tax: number;
  discount: Discount[];
  totalAmount: number;
  paymentMode: string;
  paid: boolean;
  billingDate: string;
  createdAt: string;
  updatedAt: string;
}

// Payment Status Enum
export enum PaymentStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

// Order Types Enum
export enum OrderType {
  SERVICE_ORDER = "SERVICE_ORDER",
  MEMBERSHIP = "MEMBERSHIP",
  VOUCHER = "VOUCHER", // Add more as needed (e.g., COUPON = "COUPON")
}

// Order Item Interfaces
export interface ServiceOrder {
  type: OrderType.SERVICE_ORDER;
  serviceItems: Selection[];
  amount: number;
  membershipDiscount?: number;
}

export interface ServiceOrderServiceItem {
  serviceId: string;
  quantity: number;
}

export interface MembershipOrder {
  type: OrderType.MEMBERSHIP;
  amount: number;
}

export interface VoucherOrder {
  type: OrderType.VOUCHER;
  code: string;
  amount: number;
}

export type OrderItem = ServiceOrder | MembershipOrder | VoucherOrder;

// Master Field Type
export type FieldTypeMap = {
  client: Client | undefined;
  services: Selection[];
  membership: boolean;
  paymentMode: PaymentMode | undefined;
  paymentStatus: PaymentStatus;
  bill: Bill | undefined;
  includeTax: boolean;
  billingDate: string;
};

export type OrderItems = Partial<Record<OrderType, OrderItem>>;

export type Amount = {
  subtotal: number;
  tax: number;
  membershipDiscount?: number;
  total: number;
};

export type Discount = {
  type: DiscountType;
  value: number;
};

export enum DiscountType {
  MEMBERSHIP = "MEMBERSHIP",
  VOUCHER = "VOUCHER",
}
